import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import {
    ProductCardTabFooter,
    DefaultIntlFormatValues,
    EqualWidthMessageColumns,
    PRODUCT_CARD_HORIZONTAL_PADDING_PERCENTAGE,
} from '@ratehub/base-ui';


function GICRatesFooter({
    id,
    interestCompoundTerm,
    interestPaidTerm,

    isCDIC,
    isRedeemable,

    eligibility,
}) {
    return (
        <ProductCardTabFooter
            tabBar={[
                {
                    label: <FormattedMessage {...LOCAL_MESSAGES.details} />,
                    value: FOOTER_TABS.details,
                },
            ]}
            tabPanelContent={[
                {
                    key: FOOTER_TABS.details,
                    content: (
                        <StyledEqualWidthMessageColumns
                            columns={getColumnsFromGICRates({
                                interestCompoundTerm,
                                interestPaidTerm,

                                isCDIC,
                                isRedeemable,

                                eligibility,
                            })}
                        />
                    ),
                },
            ]}
            productId={id}
        />
    );
}

GICRatesFooter.propTypes = {
    id: PropTypes.string.isRequired,
    interestCompoundTerm: PropTypes.string.isRequired,
    interestPaidTerm: PropTypes.string.isRequired,

    isCDIC: PropTypes.bool.isRequired,
    isRedeemable: PropTypes.bool.isRequired,

    eligibility: PropTypes.string,
};


const StyledEqualWidthMessageColumns = styled(EqualWidthMessageColumns)`
    padding-left: ${PRODUCT_CARD_HORIZONTAL_PADDING_PERCENTAGE};
    padding-right: ${PRODUCT_CARD_HORIZONTAL_PADDING_PERCENTAGE};
`;

// just Details for now; will grow
const FOOTER_TABS = {
    // values must be id-worthy
    details: 'details',
};

const LOCAL_MESSAGES = defineMessages({
    details: {
        id: 'web-components.gics.footer-tabs.details',
        defaultMessage: 'Details',
    },
});


function getColumnsFromGICRates({
    interestCompoundTerm,
    interestPaidTerm,

    isCDIC,
    isRedeemable,

    eligibility,
}) {
    eligibility = eligibility?.trim() || null;

    return [
        <FormattedMessage
            key="gics1"
            id="web-components.gics.footer.interest"
            defaultMessage={`Interest compounded: <b>
{interestCompoundTerm}</b>{newline}
    Interest paid: <b>
{interestPaidTerm, select,
    annually {annually}
    other {at maturity}
}</b>`}
            values={{
                interestCompoundTerm: interestCompoundTerm,
                interestPaidTerm: interestPaidTerm,
                ...DefaultIntlFormatValues,
            }}
        />,

        <FormattedMessage
            key="gics2"
            id="web-components.gics.footer.cdic-redeemable"
            defaultMessage={`Insurance: <b>
{isCDIC, select,
    true {CDIC eligible}
    other {Provincially insured}
}</b>{newline}Redeemable: <b>
{isRedeemable, select,
    true {yes}
    other {no}
}</b>`}
            values={{
                isCDIC: isCDIC,
                isRedeemable: isRedeemable,
                ...DefaultIntlFormatValues,
            }}
        />,

        <FormattedMessage
            key="gics3"
            id="web-components.gics.footer.eligibility"
            defaultMessage="Eligibility: <b>{eligibility, select, null {n/a} other {{eligibility}}}</b>"
            values={{
                eligibility: eligibility,
                ...DefaultIntlFormatValues,
            }}
        />,
    ];
}


export default GICRatesFooter;
